const INFO = {
  main: {
    title: "portfolio by harry",
    name: "Harry Yoon",
    email: "haesoo9410@gmail.com",
  },

  socials: {
    github: "https://github.com/haesoo-y",
    linkedin: "https://www.linkedin.com/in/haesoo-y/",
    instagram: "https://www.instagram.com/dev__harry/",
    blog: "https://haesoo9410.tistory.com/",
  },

  homepage: {
    title: "확장성과 안정성을 고민하는 개발자 😎",
    description:
      "5년 차 프론트엔드 개발자로, 대규모 웹 서비스 운영과 개발 경험을 보유하고 있습니다.\n\nNext.js 환경에 MFE(Micro Front-end) 아키텍처를 설계하고 도입하며, 대규모 시스템을 효율적으로 운영할 수 있도록 기여했습니다. 이를 통해 TTFB, LCP를 2배 이상 개선하고, 서비스 간 평균 이동 시간을 4.8초에서 0.5초로 단축했습니다(9.6배 향상). 뿐만 아니라 초기 설계와 템플릿 코드 설정을 주도하여 개발 생산성도 함께 향상시켰습니다. 또한, 모니터링 시스템 구축 및 테스트 코드 작성을 통해 서비스의 안정성을 높이고, 장애 발생 시 신속한 대응이 가능하도록 개선하였습니다.\n\n기획 단계부터 참여하여 백엔드와 협업하며 플랫폼을 성공적으로 출시한 경험도 있습니다. 이를 통해 개발 역량뿐만 아니라 배포 및 운영 능력까지 확장할 수 있었습니다. CI/CD 프로세스를 구축하여 효율적인 배포 환경을 마련하는 데에도 힘써왔습니다. 배포 담당자 및 팀원들과의 긴밀한 협업을 통해, 보다 안정적이고 신속한 배포가 가능하도록 자동화된 배포 시스템을 설계하고 운영하였습니다. 개발의 시작부터 배포와 운영까지 엔드 투 엔드(End-to-End) 관점에서 개선점을 고민하는 개발자로서, 앞으로도 확장 가능하고 안정적인 웹 서비스 개발에 기여하고자 합니다.",
  },

  experience: {
    title: "공유하는 개발 문화를 사랑합니다 💛",
    description:
      "공유하는 문화에 빠져 개발에 입문했습니다. 개발자로서 성장하는 것은 물론, 함께 성장하는 문화를 만들어가는 것에 행복을 느낍니다. 이를 실천하기 위해, 다양한 활동을 하고 있습니다.",
  },

  project: {
    title: "개발은 마치 마법같습니다 🪄",
    description:
      "아이디어가 현실이 되고, 문제를 해결하는 과정에서 새로운 가능성을 발견하는 것이 개발의 매력이라고 생각합니다. 저는 이 마법 같은 경험을 즐기며, 더 나은 사용자 경험과 효율적인 아키텍처를 고민하는 개발자가 되고자 합니다.",
  },

  contact: {
    title: "커피챗은 언제든 환영입니다 ☕️",
    description:
      "저에게 관심을 갖고 연락해 주셔서 감사합니다. 피드백, 질문, 제안 모두 언제든 환영합니다! 😉\n\n질문이나 의견이 있으시면 직접 이메일을 보내주세요. 24시간 내로 답변 드리도록 노력하겠습니다. 바쁜 기간에는 더 오래 걸릴 수도 있습니다.\nSNS를 통해 연락하고 싶으시다면 아래 링크를 활용해주세요! 😆\n\n다시 한번 관심 가져 주셔서 감사합니다. 연락 기다리겠습니다!",
  },
};

export default INFO;
